<template>
  <div class="dynamic-menu">
    <el-menu
      :default-active="$route.path"
      :collapse="isCollapse"
      :collapse-transition="false"
      router
      :background-color="backgroundColor"
      :text-color="textColor"
      :active-text-color="activeTextColor"
      class="dynamic-menu-el"
    >
      <template v-for="item in visibleRoutes">
        <!-- 有子菜单 -->
        <el-submenu v-if="item.children && item.children.length > 0" :index="item.path" :key="item.id">
          <template slot="title">
            <i :class="item.icon || 'el-icon-menu'"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <el-menu-item
            v-for="child in getVisibleChildren(item)"
            :key="child.id"
            :index="child.path"
          >
            <i :class="child.icon || 'el-icon-document'"></i>
            <span slot="title">{{ child.name }}</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 无子菜单 -->
        <el-menu-item v-else :index="item.path" :key="item.id">
          <i :class="item.icon || 'el-icon-document'"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DynamicMenu',
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    textColor: {
      type: String,
      default: undefined
    },
    activeTextColor: {
      type: String,
      default: undefined
    }
  },
  computed: {
    ...mapState({
      sidebarRouters: state => state.menus.sidebarRouters || []
    }),
    // 过滤掉 hidden: true 的路由
    visibleRoutes() {
      return this.sidebarRouters.filter(route => !route.hidden)
    }
  },
  methods: {
    // 获取可见的子菜单
    getVisibleChildren(route) {
      if (!route.children) return []
      return route.children.filter(child => !child.hidden)
    }
  }
};
</script>

<style scoped>
.dynamic-menu {
  height: calc(100vh - 100px);
  overflow-y: auto;
}

.dynamic-menu-el {
  border-right: none;
}

/* 自定义滚动条样式 */
.dynamic-menu::-webkit-scrollbar {
  width: 4px;
}

.dynamic-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.dynamic-menu::-webkit-scrollbar-track {
  background: transparent;
}
/* 子菜单标题样式 */
.dynamic-menu >>> .el-submenu__title:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #4facfe !important;
}

.dynamic-menu >>> .el-submenu__title:hover i {
  color: #4facfe !important;
}

.dynamic-menu >>> .el-submenu__title {
  color: #ffffff !important;
}

/* 菜单项颜色 */
.dynamic-menu >>> .el-menu-item {
  color: #ffffff !important;
}

/* 菜单项悬停样式 */
.dynamic-menu >>> .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #4facfe !important;
}

.dynamic-menu >>> .el-menu-item:hover i {
  color: #4facfe !important;
}

/* 激活菜单项高亮 */
.dynamic-menu >>> .el-menu-item.is-active {
  background: rgba(79, 172, 254, 0.35) !important;
  color: #4facfe !important;
  border-right: 3px solid #4facfe;
}

.dynamic-menu >>> .el-menu-item.is-active i {
  color: #4facfe !important;
}

/* 子菜单箭头颜色 */
.dynamic-menu >>> .el-submenu__icon-arrow {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>

<!-- 全局样式 - 覆盖 Element UI 弹出菜单 -->
<style>
/* 折叠时子菜单的样式 - 透明背景 */
.el-menu--popup {
  background: rgba(255, 255, 255, 0.7) !important;
  border: 1px solid rgba(255, 165, 0, 0.3) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

/* 弹出菜单项 - 橙黄色文字 */
.el-menu--popup .el-menu-item {
  color: #FFA500 !important;
  background: transparent !important;
}

.el-menu--popup .el-menu-item i {
  color: #FFA500 !important;
}

/* 弹出菜单项 hover - 亮橙色 */
.el-menu--popup .el-menu-item:hover {
  background: rgba(255, 165, 0, 0.15) !important;
  color: #FF8C00 !important;
}

.el-menu--popup .el-menu-item:hover i {
  color: #FF8C00 !important;
}

/* 弹出菜单项激活态 - 更深的橙色 */
.el-menu--popup .el-menu-item.is-active {
  background: rgba(255, 165, 0, 0.25) !important;
  color: #FF8C00 !important;
}

.el-menu--popup .el-menu-item.is-active i {
  color: #FF8C00 !important;
}
</style>
